import Vue from 'vue'
import Vuex from 'vuex'

import behavior from './modules/behavior'
import dashboard from './modules/dashboard'
import resource from './modules/resource'
import educationalProgram from './modules/educationalPrograms'
import userInfo from './modules/userInfo'
import folders from './modules/folders'
import statistics from './modules/statistics'
import ageRange from './modules/ageRange'
import profile from './modules/profile'
import trial from './modules/trial'
import fileUpload from './modules/fileUpload'
import faqs from './modules/faqs'
import kreaResources from './modules/kreaResources'
import kreaEducationalContent from './modules/kreaEducationalContent'
import kreaResource from './modules/kreaResource'
import kreaEducationalContents from './modules/kreaEducationalContents'
import kimpleFolders from './modules/kimpleFolders'
import team from './modules/team'
import whiteLabel from './modules/whiteLabel'
import sharingGroup from './modules/sharingGroup'
import notifications from './modules/notifications'
import registerUse from './modules/registerUse'
import usedContent from './modules/usedContent'
import newFeed from './modules/newFeed'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    behavior,
    dashboard,
    resource,
    educationalProgram,
    userInfo,
    folders,
    statistics,
    ageRange,
    profile,
    trial,
    fileUpload,
    faqs,
    kreaResources,
    kreaEducationalContent,
    kreaEducationalContents,
    kreaResource,
    kimpleFolders,
    team,
    whiteLabel,
    sharingGroup,
    notifications,
    registerUse,
    usedContent,
    newFeed
  },
  strict: process.env.NODE_ENV !== 'production'
})
